import React from "react";
import Anime from "../anime/Animex";
import Search from "../anime/Search";

export default function Index() {
  return (
    <React.Fragment>
      <Search />
      <Anime />
    </React.Fragment>
  );
}
